"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const DrawerContext = react_1.createContext({ inDrawer: false });
DrawerContext.displayName = 'DrawerContext';
exports.default = DrawerContext;
